import { CircleHelp, Star } from "lucide-react";
import React, { ReactNode } from "react";

import { IgAzurePrimitives } from "@intelligems/ig-design-tokens/constants";
import { IgAnalyticsTooltip } from "@intelligems/ig-theme/IgAnalyticsTooltip";
import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { Box, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";

interface MetricDetailSectionProps {
  children: ReactNode;
  title?: string;
  metricDetails: { title?: string; isPrimary?: boolean };
  tooltip?: string;
  borderRadius?: string;
}

export const MetricDetailSection = ({
  children,
  metricDetails,
  title,
  tooltip,
  borderRadius,
}: MetricDetailSectionProps) => {
  const theme = useTheme();
  const testId = `metric-detail${title ? `-${title.replace(" ", "-").toLowerCase()}` : ""}`;
  return (
    <Grid data-testid={testId} size={12}>
      <Box
        sx={{
          borderTopLeftRadius: borderRadius || "10px",
          borderTopRightRadius: borderRadius || "10px",
          borderBottomLeftRadius: borderRadius || "10px",
          borderBottomRightRadius: borderRadius || "10px",
          backgroundColor: "white",
          border: `1px solid ${theme.igBorders.core.default} !important`,
        }}
      >
        <Box
          sx={{
            backgroundColor: IgAzurePrimitives[100],
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
            padding: "10px 20px",
            borderBottom: `1px solid ${theme.igBorders.core.default} !important`,
          }}
        >
          <Grid container direction={"row"} alignItems={"center"}>
            {title && (
              <Grid mr={3}>
                <IgTypography fontWeight={600}>{title}</IgTypography>
              </Grid>
            )}
            {tooltip && (
              <div style={{ height: "20px" }}>
                <IgAnalyticsTooltip title={tooltip}>
                  <CircleHelp
                    size={18}
                    style={{
                      marginLeft: "5px",
                    }}
                  />
                </IgAnalyticsTooltip>
              </div>
            )}
            {metricDetails.isPrimary ? (
              <Star
                color={theme.igPrimitives.yellow[500]}
                size={20}
                style={{
                  marginRight: "4px",
                }}
              />
            ) : null}
            {metricDetails?.title && (
              <Grid>
                <IgTypography>{metricDetails.title}</IgTypography>
              </Grid>
            )}
          </Grid>
        </Box>
        <>{children}</>
      </Box>
    </Grid>
  );
};
